import EmptyState from "./EmptyState";
import {CustomSpinner} from "./CustomSpinner";
import {DangerButton} from "./CustomButton";

function CustomTableItemLoader({
                              loading = false,
                              error = '',
                              isEmpty = false,
                              retry,
                              count = 2,
                              keyName = '',
                              loaderItemHeight,
                              loaderItemWidth,
                              colSpan,
                              isCircular = false,
                              isTableFilter = false,
                              emptyStateMessage,
                              emptyStateIcon,
                              children
                            }) {
  const getShimmerByCount = () => {
    return Array.from({length: count}, (_, i) =>
      <div key={`${keyName}-${i}`}
           className={`${loaderItemHeight ? loaderItemHeight : "h-[82px]"} ${loaderItemWidth ? loaderItemWidth : "w-full"} animate-pulse bg-gray-200 rounded-md w-full mb-2.5`}/>,
    )
  }
  return (
    <tbody>
    <tr>
      <td colSpan={colSpan}>
        {
          (!!error) ?
            <div className='flex justify-center items-center'>
              <div className='space-y-4 text-center flex flex-col items-center'>
                <p className='text-red-500'>{error ?? 'Error loading data.'}</p>
                <DangerButton onClick={retry}>Retry</DangerButton>
              </div>
            </div>
            :
            (isEmpty && !loading) ?
              <EmptyState message={emptyStateMessage ?? "No records to display."} icon={emptyStateIcon ?? "folder_open"}/>
              : children ? children : (isCircular ?
                <div
                  className={`w-full ${loaderItemHeight ? loaderItemHeight : "h-52"} flex justify-center items-center`}>
                  <CustomSpinner/>
                </div> :
                isTableFilter ? <div className="flex justify-between mb-2">
                    <div className="bg-gray-200 w-60 h-[38px] app-rounded"></div>
                    <div className="bg-gray-200 w-60 h-[38px] app-rounded"></div>
                  </div> :
                  <>
                    {getShimmerByCount()}
                  </>)}
      </td>
    </tr></tbody>
  )
}

export default CustomTableItemLoader